import React from 'react';

const Blogs = () => {
  return (
    <div className="blog-container h-[100vh]">
      <h1 className="m-auto">hello worlds</h1>
    </div>
  );
};

export default Blogs;
